import {isNotNil} from 'ramda';
import {isTrue} from 'ramda-adjunct';

import {SaveSaleVehicleFinancingBody} from '@dms/api/vehicle';

import {FINANCING_COST_OVERRIDES} from '../../constants/FINANCING_COST_OVERRIDES';

/**
 * Counts the overrides the current tenant can see, so the panel never advertises an override the
 * user cannot reach. One cost counts once, no matter whether its amount, its inclusion, or both are
 * overridden.
 *
 * A manual configuration stores its interest rate type even when it is the fixed rate the field
 * defaults to, so only another type counts as an override there.
 */
export function countVisibleFinancingOverrides(
  body: SaveSaleVehicleFinancingBody,
  isGermanTenant: boolean
) {
  const commonOverrides = [isNotNil(body.processingFeeOverride)];
  const costOverrides = FINANCING_COST_OVERRIDES.map(
    (override) =>
      isNotNil(body[override.includedOverrideKey]) || isNotNil(body[override.amountOverrideKey])
  );
  const isInterestRateTypeOverridden =
    body.mode === 'MANUAL'
      ? isNotNil(body.interestRateTypeOverride) && body.interestRateTypeOverride !== 'FIXED'
      : isNotNil(body.interestRateTypeOverride);
  const germanOverrides = [
    isInterestRateTypeOverridden,
    ...costOverrides,
    isNotNil(body.tradeInPossibleOverride),
  ];

  return [...commonOverrides, ...(isGermanTenant ? germanOverrides : [])].filter(isTrue).length;
}
